import { Injectable } from '@angular/core';
import SafeUrlAssembler from 'safe-url-assembler';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';

@Injectable()
export class ChangePasswordService {

  private httpClient:HttpClient;

  constructor(private apiEndpointService: ApiEndpointService,
    private httpBackend: HttpBackend) {
      this.httpClient = new HttpClient(this.httpBackend);    
  }

  /**
   * Change Password.
   *   
   * @param {string} token
   * @param {string} password
   * @returns {Observable<any>}
   */
  public changePassword(token: string, password: string) {
    var data = {
      Password: password
    };    

    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('changePasswordByToken'))
      .param('token', token)
      .toString();
    return this.httpClient.put<any>(endpoint, data);
  }


}
